import { RouteEditTab } from "../../RouteEditTab";
import { PdsrClientViewModel } from "../../../ViewModel/PdsrClientViewModel";
import { FtlRouteViewModel } from "../../../ViewModel/FtlRouteViewModel";

export default function getPdsrsForList(
  routeEditTabSelected: RouteEditTab,
  pdsrs?: Array<PdsrClientViewModel>,
  FTLRoutes?: Array<FtlRouteViewModel>
) {
  switch (routeEditTabSelected) {
    case RouteEditTab.Ftl:
      return getPdsrForFtlView(pdsrs);
    case RouteEditTab.Ltl:
      return getPdsrForLtlView(pdsrs, FTLRoutes);
    default:
      throw new Error(
        `getPdsrs not implemented for RouteEditTab ${routeEditTabSelected}`
      );
  }
}

function getPdsrForFtlView(pdsrs: Array<PdsrClientViewModel> | undefined) {
  return pdsrs;
}

function getPdsrForLtlView(
  pdsrs: Array<PdsrClientViewModel> | undefined,
  FTLRoutes: Array<FtlRouteViewModel> | undefined
) {
  if (!pdsrs) {
    return [];
  }

  const list: Array<PdsrClientViewModel> = [];
  // Alle Pdsrs, die nicht einer Route zugeordnet wurden
  addToListIfNotExists(list, getPdsrsWhichAreNotAssignedToRoute(pdsrs));

  // Alle Pdsrs, die dem Routen-Typen FTL2 zugeordnet wurden
  addToListIfNotExists(list, getPdsrsWhichAreFtl2(pdsrs, FTLRoutes));

  // Alle Pdsrs, die dem Routen-Typen Top-Up zugeordnet wurden und in der Pdsr Liste ein ODC mit dem  Vermerkt „Unload“ definiert wurde.
  addToListIfNotExists(
    list,
    getPdsrsWhichAreTopupAndOdcUnload(pdsrs, FTLRoutes)
  );

  return list;
}

const getPdsrsWhichAreNotAssignedToRoute = (
  pdsrs?: Array<PdsrClientViewModel>
): Array<PdsrClientViewModel> =>
  pdsrs?.filter((x) => x.UsedInFtlRoutes === 0) || [];

const addToListIfNotExists = (
  list: Array<PdsrClientViewModel>,
  newItems: Array<PdsrClientViewModel>
) => {
  newItems.forEach((newItem) => {
    const listPdsr = list.filter((x) => x.PdsrId === newItem.PdsrId);
    const missingInList = listPdsr.length === 0;
    if (!missingInList) {
      return;
    }

    list.push(newItem);
  });
};

const getPdsrsWhichAreFtl2 = (
  pdsrs?: Array<PdsrClientViewModel>,
  FTLRoutes?: Array<FtlRouteViewModel>
) => {
  if (!pdsrs) {
    return [];
  }

  let list: Array<PdsrClientViewModel> = [];

  const ftl2Routes = FTLRoutes?.filter((x) => x.RouteType === "FTL2");
  ftl2Routes?.forEach((route) => {
    if (!route.PdsrsOnThisRoute) {
      return;
    }

    route.PdsrsOnThisRoute.forEach((pdsrOnThisRoute) => {
      const projectPdsr = pdsrs?.filter(
        (x) => x.PdsrId === pdsrOnThisRoute.PdsrId
      );
      list = list.concat(projectPdsr);
    });
  });
  return list;
};

const getPdsrsWhichAreTopupAndOdcUnload = (
  pdsrs?: Array<PdsrClientViewModel>,
  FTLRoutes?: Array<FtlRouteViewModel>
) => {
  if (!pdsrs) {
    return [];
  }

  let list: Array<PdsrClientViewModel> = [];

  const topUpRoutes = FTLRoutes?.filter((x) => x.RouteType === "Top-Up");
  topUpRoutes?.forEach((route) => {
    if (!route.PdsrsOnThisRoute) {
      return;
    }

    route.PdsrsOnThisRoute.forEach((pdsrOnThisRoute) => {
      if (!pdsrOnThisRoute) {
        return;
      }

      const odcs = pdsrOnThisRoute.ODCs;
      if (!odcs || odcs.length === 0) {
        return;
      }

      odcs.forEach((pdsrWithOdcMark) => {
        if (pdsrWithOdcMark.LoadType !== "Unload") {
          return;
        }

        const projectPdsr = pdsrs?.filter(
          (x) => x.PdsrId === pdsrOnThisRoute.PdsrId
        );
        list = list.concat(projectPdsr);
      });
    });
  });

  return list;
};
